import React, { CSSProperties } from "react";
import { getBlockOption } from "modules/MainSurveyEditor/helpers/blocks";

export const BlockIcon = (props: { blockType: string }) => {
  const { blockType } = props;
  const block = React.useMemo(() => getBlockOption(blockType), [blockType]);

  return (
    <div className="module-block-icon" style={{ "--icon-color": block.color } as CSSProperties}>
      {block.icon}
    </div>
  );
};
